import type { RouterConfig } from '@nuxt/schema'

// Vue Router's default scrollBehavior runs `document.querySelector(hash)` when a
// route has a hash, treating it as an anchor target. Panel hashes contain `/`
// and `?` (e.g. `#customer/edit?id=123`), which are invalid CSS selectors and
// produce console warnings on every panel open. Override to skip the anchor
// scroll for any hash that isn't a plain CSS id.
const VALID_ID_HASH = /^#[A-Za-z][\w-]*$/

export default <RouterConfig>{
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash && VALID_ID_HASH.test(to.hash)) {
      const el = document.querySelector(to.hash)
      if (el) return { el: to.hash, top: 0 }
    }
    return { top: 0 }
  },
}
